import { includeBasePath } from 'bc-artifacts-client/utils';
import type { FeatureFlagKey } from 'bc-model';

let featureFlags: Record<string, boolean> | null = null;

/**
 * Resets the internal feature flags state. Intended for testing only.
 */
const resetFeatureFlags = (): void => {
  featureFlags = null;
};

const reloadFeatureFlags = async (): Promise<boolean> => {
  try {
    const response = await fetch(includeBasePath('/api/feature-flags/values'));
    const responseJson = await response.json();
    featureFlags = responseJson.values;
    return true;
  } catch (err) {
    return false;
  }
};

const areFeatureFlagsLoaded = (): boolean => {
  return featureFlags !== null;
};

const getFeatureFlags = (): Record<string, boolean> | null => {
  return featureFlags;
};

const getFeatureFlag = (key: string): boolean | null => {
  if (!featureFlags) return null;
  return featureFlags[key] ?? null;
};

/**
 * @deprecated: Use hook `useBooleanFlagValue`
 */
const isFeatureFlagEnabled = (key: FeatureFlagKey): boolean => {
  const flag = getFeatureFlag(key);
  return flag || false;
};

export {
  reloadFeatureFlags,
  areFeatureFlagsLoaded,
  getFeatureFlag,
  getFeatureFlags,
  isFeatureFlagEnabled,
  resetFeatureFlags,
};
